// FlixPlayerActionButton.js
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import FlixPlayerActionButton from '../component/FlixPlayerActionButton.jsx';

import { replace } from '../action/navigationAction.js';
import login from '../action/login.js';
import sendUnlockMessage from '../action/sendUnlockMessage.js';

import getMessageData from '../selector/getMessageData.js';
import getMeData from '../selector/getMeData.js';
import getMessageUnlockPrice from '../selector/getMessageUnlockPrice.js';
import getUnlockButtonStatus from '../selector/getUnlockButtonStatus.js';

const mapStateToProps = (state, { messageId }) => {
  const unlockPrice = getMessageUnlockPrice(state, messageId);
  const unlockButtonStatus = getUnlockButtonStatus(state, messageId);

  return {
    isAuthed: !!getMeData(state, 'id'),
    unlockButtonStatus,
    unlockPrice,
    canViewMedia: getMessageData(state, messageId, 'canViewMedia'),
    badges: getMessageData(state, messageId, 'badges'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    sendUnlockMessage: data => dispatch(sendUnlockMessage(data)),
    replace: data => dispatch(replace(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlixPlayerActionButton)
);
